import 'bootstrap'

function handleImageCaptionToggleEvents() {
  const images = document.querySelectorAll('.image-inner-caption-toggle')

  images.forEach((image) => {
    const imageCaptionText = image.querySelector('.image-inner-caption-text')
    if (imageCaptionText) {
      image.addEventListener('focus', (event) => {
        showCaptionText(imageCaptionText)
      })
      image.addEventListener('unfocusout', (event) => {
        hideCaptionText(imageCaptionText)
      })
      image.addEventListener('mouseenter', (event) => {
        showCaptionText(imageCaptionText)
      })
      image.addEventListener('mouseleave', (event) => {
        hideCaptionText(imageCaptionText)
      })
    }
  })
}

function showCaptionText(captionText) {
  captionText.classList.add('show')
  captionText.style.maxHeight = `${captionText.closest('.image-inner').clientHeight}px`
}

function hideCaptionText(captionText) {
  captionText.classList.remove('show')
  captionText.style.maxHeight = `0px`
}

document.addEventListener('DOMContentLoaded', (event) => {
  handleImageCaptionToggleEvents()
})
